import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const Home = () => {
  const [mcStatus, setMcStatus] = useState(null);
  const [discordStatus, setDiscordStatus] = useState(null);

  useEffect(() => {
    fetch("https://api.mcsrvstat.us/2/play.rixxymc.fun:25565")
      .then((res) => res.json())
      .then((data) => setMcStatus(data))
      .catch(() => setMcStatus(null));
  }, []);

  useEffect(() => {
    fetch("https://discord.com/api/guilds/1291772991860113581/widget.json")
      .then((res) => res.json())
      .then((data) => setDiscordStatus(data))
      .catch(() => setDiscordStatus(null));
  }, []);

  const copyIP = () => {
    navigator.clipboard.writeText("play.rixxymc.fun:25565");
    const alertBox = document.createElement("div");
    alertBox.innerText = "✅ IP Copied to Clipboard!";
    alertBox.className = "copy-alert";
    document.body.appendChild(alertBox);
    setTimeout(() => alertBox.remove(), 2000);
  };

  return (
    <div className="home-page">
      {/* Top Info Section */}
      <section className="top-info-bar">
        <article className="info-card">
          <h3>🎮 Minecraft Server</h3>
          {mcStatus ? (
            <>
              <p><strong>Status:</strong> {mcStatus.online ? "🟢 Online" : "🔴 Offline"}</p>
              {mcStatus.online && (
                <p><strong>Players:</strong> {mcStatus.players?.online ?? 0}/{mcStatus.players?.max ?? "?"}</p>
              )}
              <p><strong>IP:</strong> play.rixxymc.fun:25565</p>
            </>
          ) : (
            <p>Loading server status...</p>
          )}
        </article>

        <article className="info-card">
          <h3>💬 Discord Status</h3>
          {discordStatus ? (
            <>
              <p><strong>Online Members:</strong> {discordStatus.presence_count}</p>
              <a
                href="https://discord.rixxymc.fun/"
                className="discord-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join Discord
              </a>
            </>
          ) : (
            <p>Loading Discord status...</p>
          )}
        </article>
      </section>

      {/* Welcome Section */}
      <section className="welcome-section">
        <h1>👋 Welcome to <span className="highlight">RixxyMC</span>!</h1>
        <p>
          Explore India’s #1 <strong>LifeSteal Minecraft server</strong> – smooth, cross-platform, lag-free fun.
          Available 24/7 on Java, Bedrock & Pocket Edition.
        </p>
      </section>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-image">
          <img src="/images/rixxymc-banner5.gif" alt="Minecraft World" />
        </div>
        <div className="hero-content">
          <h2>🔥 Why Choose RixxyMC?</h2>
          <p>
            Join a thriving <strong>community</strong> with exciting <strong>LifeSteal gameplay</strong>, low ping,
            cracked/premium support, and constant events. Build your legacy today!
          </p>
          <div className="hero-buttons">
            <a
              href="https://discord.rixxymc.fun/"
              target="_blank"
              rel="noopener noreferrer"
              className="join-button"
            >
              Join Us Now
            </a>
            <button className="copy-ip-button" onClick={copyIP}>
              Copy Server IP
            </button>
          </div>
        </div>
      </section>

      {/* Updates Section */}
      <section className="updates-section">
        <h2>📢 Latest Updates</h2>
        <ul className="updates-list">
          <li><strong>✅ Survival Season 01</strong> launched with brand new features and rewards!</li>
          <li><strong>⚔️ Practice PvP</strong> is now live — 1v1, Sumo, Boxing & more!</li>
          <li><strong>🎉 Server Reset Complete</strong> — Enjoy optimized performance & smoother gameplay.</li>
          <li><strong>🔧 UI Improvements</strong> across vote pages, ranks, and claim shops.</li>
        </ul>
      </section>

      {/* Vote Section */}
      <section className="vote-section">
        <h3>🎁 Vote & Earn Rewards!</h3>
        <Link to="/vote">
          <button className="vote-button">Vote Now</button>
        </Link>
      </section>

      {/* Why Play on RixxyMC Section */}
      <section className="features-section">
        <h2>✨ Why Play on RixxyMC?</h2>
        <div className="features-grid">
          <article className="feature-card">
            <h3>💖 LifeSteal Experience</h3>
            <p>Survive, fight, and steal hearts. Each kill boosts your power in this intense PvP world.</p>
          </article>
          <article className="feature-card">
            <h3>🧱 Survival Season 01</h3>
            <p>Play the all-new Survival with clean economy, quests, shops, and powerful custom ranks.</p>
          </article>
          <article className="feature-card">
            <h3>⚔️ Practice PvP</h3>
            <p>1v1s, Boxing, Sumo & more — all optimized for skill-based combat and smooth gameplay.</p>
          </article>
          <article className="feature-card">
            <h3>🛡️ Cracked + Premium</h3>
            <p>Join with any launcher — everyone is welcome on RixxyMC!</p>
          </article>
          <article className="feature-card">
            <h3>🎉 Weekly Events</h3>
            <p>Take part in events like Tournaments, KOTH, Parkour Races and Win Big!</p>
          </article>
          <article className="feature-card">
            <h3>📦 Free Giveaways</h3>
            <p>Ranks, Kits, Crates, and Coins — join Discord to enter and win rewards!</p>
          </article>
        </div>
      </section>
    </div>
  );
};

export default Home;
